import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_59de254c from 'nuxt_plugin_plugin_59de254c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_67ebf269 from 'nuxt_plugin_vuesocialsharingplugin_67ebf269' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_nuxtvuexlocalstorage_67ade1e7 from 'nuxt_plugin_nuxtvuexlocalstorage_67ade1e7' // Source: ./nuxt-vuex-localstorage.js (mode: 'client')
import nuxt_plugin_axios_ce0e6120 from 'nuxt_plugin_axios_ce0e6120' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_elementui_d905880e from 'nuxt_plugin_elementui_d905880e' // Source: ../../../src/plugins/element-ui (mode: 'all')
import nuxt_plugin_filter_2aab3a6c from 'nuxt_plugin_filter_2aab3a6c' // Source: ../../../src/plugins/filter (mode: 'all')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../../../src/plugins/axios (mode: 'all')
import nuxt_plugin_api_caeae0b4 from 'nuxt_plugin_api_caeae0b4' // Source: ../../../src/plugins/api (mode: 'all')
import nuxt_plugin_svgicon_16778036 from 'nuxt_plugin_svgicon_16778036' // Source: ../../../src/plugins/svg-icon (mode: 'all')
import nuxt_plugin_lazycomponent_8203e650 from 'nuxt_plugin_lazycomponent_8203e650' // Source: ../../../src/plugins/lazy-component (mode: 'all')
import nuxt_plugin_socket_412a8e67 from 'nuxt_plugin_socket_412a8e67' // Source: ../../../src/plugins/socket (mode: 'all')
import nuxt_plugin_vueGtag_e5b9e7f6 from 'nuxt_plugin_vueGtag_e5b9e7f6' // Source: ../../../src/plugins/vueGtag (mode: 'client')
import nuxt_plugin_vueClipboard_41101ab8 from 'nuxt_plugin_vueClipboard_41101ab8' // Source: ../../../src/plugins/vueClipboard (mode: 'client')
import nuxt_plugin_vuefbcustomerchat_1658e1f1 from 'nuxt_plugin_vuefbcustomerchat_1658e1f1' // Source: ../../../src/plugins/vue-fb-customer-chat (mode: 'client')
import nuxt_plugin_jsonld_60b3ba23 from 'nuxt_plugin_jsonld_60b3ba23' // Source: ../../../src/plugins/jsonld.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"STEP1NE｜獵才好選擇 求職好夥伴","htmlAttrs":{"lang":"zh-Hant-TW"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1"},{"name":"robots","content":"ALL"},{"name":"format-detection","content":"telephone=no"},{"hid":"keywords","name":"keywords","content":"獵頭,科技獵頭,獵頭網站,找工作平台,高薪工作,高薪職業,獵頭公司,獵頭排名,高階獵頭,求職,職缺,Head Hunter"},{"hid":"description","name":"description","content":"專業獵頭團隊 — 精準匹配 快速搜尋，借助行銷科技挖掘潛在人才，進一步提升職缺行銷，塑造智能招募的全新紀元。STEP1NE 敏銳掌握各產業趨勢，深知各界即時動態，專精於獵才領域，為企業廣納菁英的求職徵才平台。"},{"hid":"url","property":"url","content":"https:\u002F\u002Fstep1ne.com\u002F"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fstep1ne.com\u002F"},{"hid":"og:title","property":"og:title","content":"STEP1NE｜獵才好選擇 求職好夥伴"},{"hid":"og:site_name","property":"og:site_name","content":"STEP1NE｜獵才好選擇 求職好夥伴"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fstep1ne.com\u002F"},{"hid":"og:image","property":"og:image","content":".\u002Ffb.jpg"},{"hid":"og:description","property":"og:description","content":"專業獵頭團隊 — 精準匹配 快速搜尋，借助行銷科技挖掘潛在人才，進一步提升職缺行銷，塑造智能招募的全新紀元。STEP1NE 敏銳掌握各產業趨勢，深知各界即時動態，專精於獵才領域，為企業廣納菁英的求職徵才平台。"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":".\u002Ffavicon.ico"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_59de254c === 'function') {
    await nuxt_plugin_plugin_59de254c(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_67ebf269 === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_67ebf269(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtvuexlocalstorage_67ade1e7 === 'function') {
    await nuxt_plugin_nuxtvuexlocalstorage_67ade1e7(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_ce0e6120 === 'function') {
    await nuxt_plugin_axios_ce0e6120(app.context, inject)
  }

  if (typeof nuxt_plugin_elementui_d905880e === 'function') {
    await nuxt_plugin_elementui_d905880e(app.context, inject)
  }

  if (typeof nuxt_plugin_filter_2aab3a6c === 'function') {
    await nuxt_plugin_filter_2aab3a6c(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (typeof nuxt_plugin_api_caeae0b4 === 'function') {
    await nuxt_plugin_api_caeae0b4(app.context, inject)
  }

  if (typeof nuxt_plugin_svgicon_16778036 === 'function') {
    await nuxt_plugin_svgicon_16778036(app.context, inject)
  }

  if (typeof nuxt_plugin_lazycomponent_8203e650 === 'function') {
    await nuxt_plugin_lazycomponent_8203e650(app.context, inject)
  }

  if (typeof nuxt_plugin_socket_412a8e67 === 'function') {
    await nuxt_plugin_socket_412a8e67(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueGtag_e5b9e7f6 === 'function') {
    await nuxt_plugin_vueGtag_e5b9e7f6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueClipboard_41101ab8 === 'function') {
    await nuxt_plugin_vueClipboard_41101ab8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuefbcustomerchat_1658e1f1 === 'function') {
    await nuxt_plugin_vuefbcustomerchat_1658e1f1(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_60b3ba23 === 'function') {
    await nuxt_plugin_jsonld_60b3ba23(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
